import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

export const initGallery = (): void => {
  // Clear any existing ScrollTriggers to prevent duplicate instances during Vite HMR
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.trigger && (trigger.trigger as HTMLElement).id === 'plantillas') {
      trigger.kill();
    }
  });

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const phones = Array.from(document.querySelectorAll<HTMLElement>('.gallery-phone'));
  const prevBtn = document.getElementById('gallery-prev') as HTMLButtonElement | null;
  const nextBtn = document.getElementById('gallery-next') as HTMLButtonElement | null;
  const dots = Array.from(document.querySelectorAll<HTMLButtonElement>('.gallery-dot'));

  let activeIndex = Math.min(1, Math.max(0, phones.length - 1));

  const applyGalleryState = (): void => {
    const previousIndex = (activeIndex - 1 + phones.length) % phones.length;

    phones.forEach((phone, index) => {
      const isActive = index === activeIndex;
      const isPrevious = index === previousIndex;

      phone.classList.toggle('is-active', isActive);
      phone.classList.toggle('is-side', !isActive);
      phone.classList.toggle('is-left', !isActive && isPrevious);
      phone.classList.toggle('is-right', !isActive && !isPrevious);
      phone.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  const setActivePhone = (nextIndex: number): void => {
    if (phones.length === 0) return;

    const normalizedIndex = (nextIndex + phones.length) % phones.length;
    if (normalizedIndex === activeIndex) return;

    activeIndex = normalizedIndex;
    applyGalleryState();
  };

  applyGalleryState();

  prevBtn?.addEventListener('click', () => setActivePhone(activeIndex - 1));
  nextBtn?.addEventListener('click', () => setActivePhone(activeIndex + 1));
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = Number(dot.dataset.galleryDot);
      if (!Number.isNaN(index)) setActivePhone(index);
    });
  });

  // GSAP ScrollTrigger Stagger Animation for static iPhone mockups
  if (phones.length > 0) {
    gsap.from(phones, {
      scrollTrigger: {
        trigger: '#plantillas',
        start: 'top 75%', // Starts animation when section top is 75% of viewport height
        once: true,
      },
      y: prefersReducedMotion ? 0 : 50,
      opacity: 0,
      duration: prefersReducedMotion ? 0 : 0.8,
      stagger: prefersReducedMotion ? 0 : 0.15,
      ease: 'power3.out',
      immediateRender: false,
      clearProps: 'opacity,transform',
    });
  }
};
